import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/config/constants';
import { UserService } from 'src/app/core/services/user.service';
//import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl} from '@angular/platform-browser'
import Swal from 'sweetalert2';
//import { interval } from 'rxjs';
import { Router } from '@angular/router';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss']
})
export class ForgotPasswordPageComponent implements OnInit {
  
  showemailErrorMsg:any;
  email: any;
  emailMsg: string;
  passw:any;
  loading: boolean;
    error: string;
  msgfinal: string;
  msg: string;
  portal: string="BSHP";
  isResetMyself: boolean=false;

  constructor(public user: UserService, public config: Config, public router: Router) { }

  ngOnInit(): void {
  }


  ValidateEmail(cemail) {
    if (/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(cemail)) {
    return (true);
    }
    this.showemailErrorMsg = true;
    return (false);
    }
    emailErrorMsg() {
  
      if (this.ValidateEmail(this.email) == false) {
      this.showemailErrorMsg = true;
      this.emailMsg="Please enter valid username";
      }
      else
      {
      this.showemailErrorMsg = false;
      }
      }
      resetLink(){
          
        var flag=true
        this.showemailErrorMsg = false;
        var errormsg=[];
         if(!this.email || this.email.length <= 0){this.showemailErrorMsg = true;  flag=false; errormsg.push('Email')} 
        // else{
        //   this.msg = errormsg.toString();
        //   this.msgfinal = this.msg.replace(",", '<br />');
        //   // Swal.fire("", "Please fill following mandatory field(s)" + "<br>" + this.msgfinal, 'warning')
        // }  
        if(this.checkForCaptcha==false){
          this.error = "To proceed with login, please select the box to confirm you are not a robot."
          flag=false;
         }
        if  (flag == true) {
//  this.recaptchaV3Service.execute('submit_form').subscribe((token: string) => {
//       const formData = {
//          email: this.email,
//         recaptchaToken: token,
//       };
//       //  console.log('Form data to submit:', formData);
// this.user.getV3RecaptchaVerification(formData.recaptchaToken).subscribe((data:any) =>{
//      debugger
//     if(data.success==true) {
          this.portal="BSHP";      
        this.user.Forgetpassword(this.email,this.portal,this.isResetMyself).pipe()
        .subscribe(
            data => { 
              //  (data);
              // Swal.fire("Password reset link sent successfully.");
              // Swal.fire("", data.data).then(() => {
              //   this.router.navigateByUrl("/login")
              // });
              if(data.success==true){
                Swal.fire("", data.data)
                // this.router.navigateByUrl("/login")
              }
              else{
              Swal.fire("", data.data)
            }
              // this.router.navigateByUrl("/set-new-password")

        //    this.email;
            },error=>{
              //  if(this.baseservice.handleError(error)){
                 //handle Exception from Server 404,401
                if(error.status == 400 || error.status==417){
                    this.error=error.error.data;
                    this.loading = false;
                 }
                 else{
                    this.loading = false;
      
                   this.error="Something went wrong. Please refresh the page and try again.";
                 }
             //  }
                },()=>{});
                
    //   }
    //   else{
    // // this.error="reCaptcha Verification Failed";
    //  }
    // },error=>{{
    // }},()=>{});
      
    // });
  }
      else {
        if(this.checkForCaptcha==false){
          this.error = "To proceed with login, please select the box to confirm you are not a robot."  
         }
        }
    }
    checkForCaptcha:boolean=false;
    resolved(captchaResponse: any) {
      //debugger
      if(captchaResponse==null){
        this.checkForCaptcha=false;
      }else{
        this.checkForCaptcha=true;
      }
    }
}
